"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _gsap = require("gsap");

var _default = {
  Power1: _gsap.Power1,
  Power2: _gsap.Power2,
  Power3: _gsap.Power3,
  Power4: _gsap.Power4
};
exports["default"] = _default;